module.exports = __webpack_public_path__ + "img/ico_device_mobile.ed00c45d.svg";